import * as styles from "./Loading.module.scss";

export const Loading = () => {
  return (
    <div className={styles.loading}>
      <svg viewBox="0 0 30 30" role="img" aria-label="loading">
        <rect
          rx="1.5"
          x="13.5"
          className={`${styles.loadingPath} ${styles._no1}`}
        />
        <rect
          rx="1.5"
          transform="rotate(45 22.425 7.576)"
          x="20.925"
          y="3.075"
          className={`${styles.loadingPath} ${styles._no2}`}
        />
        <rect
          rx="1.5"
          transform="rotate(90 25.5 15)"
          x="24"
          y="10.5"
          className={`${styles.loadingPath} ${styles._no3}`}
        />
        <rect
          transform="rotate(-45)"
          rx="1.5"
          x="-1.5"
          y="28"
          className={`${styles.loadingPath} ${styles._no4}`}
        />
        <rect
          rx="1.5"
          x="13.5"
          y="21"
          className={`${styles.loadingPath} ${styles._no5}`}
        />
        <rect
          transform="rotate(45)"
          rx="1.5"
          x="19.5"
          y="6"
          className={`${styles.loadingPath} ${styles._no6}`}
        />
        <rect
          rx="1.5"
          transform="rotate(90 4.5 15)"
          x="3"
          y="10.5"
          className={`${styles.loadingPath} ${styles._no7}`}
        />
        <rect
          rx="1.5"
          transform="rotate(135 7.576 7.575)"
          x="6.075"
          y="3.075"
          className={`${styles.loadingPath} ${styles._no8}`}
        />
      </svg>
    </div>
  );
};
